var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_443_14150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.3817 13.1983C33.1965 12.2296 30.8531 11.5159 28.403 11.1072C28.3584 11.0993 28.3139 11.119 28.2909 11.1584C27.9895 11.6763 27.6556 12.3519 27.4219 12.8829C24.7865 12.5017 22.1649 12.5017 19.5837 12.8829C19.3499 12.3401 19.0039 11.6763 18.7012 11.1584C18.6782 11.1203 18.6336 11.1006 18.5889 11.1072C16.1402 11.5146 13.7968 12.2283 11.6102 13.1983C11.5913 13.2062 11.575 13.2194 11.5643 13.2364C7.11942 19.6518 5.90178 25.9095 6.49911 32.0897C6.50181 32.1198 6.51939 32.1488 6.54371 32.1672C9.47631 34.2478 12.317 35.5109 15.105 36.3481C15.1496 36.3613 15.1969 36.3456 15.2253 36.3101C15.8848 35.4399 16.4726 34.5226 16.9767 33.5578C17.0064 33.5012 16.978 33.4342 16.9172 33.4119C15.9848 33.0701 15.0968 32.6535 14.2428 32.1804C14.1752 32.1421 14.1698 32.0489 14.2319 32.0041C14.4117 31.874 14.5915 31.7386 14.7631 31.602C14.7941 31.5771 14.8374 31.5718 14.8739 31.5876C20.4851 34.0625 26.5596 34.0625 32.1045 31.5876C32.141 31.5704 32.1842 31.5757 32.2166 31.6006C32.3884 31.7374 32.568 31.874 32.7492 32.0041C32.8113 32.0489 32.8073 32.1421 32.7396 32.1804C31.8856 32.6626 30.9977 33.0701 30.0638 33.4105C30.0031 33.433 29.976 33.5012 30.0059 33.5578C30.5207 34.5212 31.1085 35.4385 31.7558 36.3087C31.7829 36.3456 31.8316 36.3613 31.8761 36.3481C34.6776 35.5109 37.5184 34.2478 40.4508 32.1672C40.4765 32.1488 40.4928 32.1212 40.4956 32.0909C41.2104 24.9461 39.2981 18.7397 35.4263 13.2378C35.4168 13.2194 35.4007 13.2062 35.3817 13.1983ZM17.8145 28.3266C16.1253 28.3266 14.7333 26.8282 14.7333 24.9881C14.7333 23.148 16.0983 21.6497 17.8145 21.6497C19.5444 21.6497 20.9229 23.1612 20.8958 24.9881C20.8958 26.8282 19.5309 28.3266 17.8145 28.3266ZM29.207 28.3266C27.5177 28.3266 26.1259 26.8282 26.1259 24.9881C26.1259 23.148 27.4908 21.6497 29.207 21.6497C30.9369 21.6497 32.3153 23.1612 32.2884 24.9881C32.2884 26.8282 30.9369 28.3266 29.207 28.3266Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_443_14150",
    x: 6.35742,
    y: 11.1055,
    width: 34.2861,
    height: 25.248,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_443_14150"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.9b08b27c14d31d9d9c4a64e3c0dcfd6e.svg";
export { ForwardRef as ReactComponent };